// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDLtkLJheEoIzxbFXxEZgCQ30ZtjEnQw30",
    authDomain: "imagine-bc615.firebaseapp.com",
    databaseURL: "https://imagine-bc615-default-rtdb.firebaseio.com",
    projectId: "imagine-bc615",
    storageBucket: "imagine-bc615.appspot.com",
    messagingSenderId: "576503878859",
    appId: "1:576503878859:web:8d33a75eeef5f44d7ef74e",
    measurementId: "G-VSC3W9JXTB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const db = getFirestore(app)
export default app;